import axios from 'axios'
import { Toast } from 'antd-mobile';
import qs from "qs";
import Config from '../config';

const host = Config.API_HOST

//axios.defaults.withCredentials = true
// const header = {
// "content-type": "application/x-www-form-urlencoded"
// "content-type": "multipart/form-data"
// "content-type": "application/json"
// }

const post_applets = (url, params = {}) => {
  return new Promise((resolve, reject) => {
    let param = { ...params }
    axios({
      headers: {
        "content-type": "application/json",
      },
      method: 'post',
      url: host + url,  
      data: param
    }).then(res=>{
      console.log(res)
      resolve(res)
    })
  })
}

const get_applets = (url, params = {}) => {
  return new Promise((resolve, reject) => {
    let param = { ...params };
    axios({
      headers: {
        "content-type": "application/x-www-form-urlencoded",
      },
      method: 'get',
      url: host + url,  
      params: param
    }).then(res=>{
      console.log(res)
      resolve(res)
    })
  })
}

const post = (url, params = {}) => {
  return new Promise((resolve, reject) => {
    let param = { ...params }
    let qsParam = qs.stringify(params)
    let token = window.localStorage.getItem('token')
    //token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiNDciLCJpc3MiOiJTZXJ2aWNlIiwidGltZSI6MTYzMTA5MDQ4NDA2MywiaWF0IjoxNjMxMDkwNDg0fQ.-5YDaphwTJGkgbSijHpE00icNufb1zKsH8OweJAJbAw'

    if(token != "" && token != undefined && token != 'undefined'){
      axios({
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          //"content-type": "application/json",
          "token": token
        },
        method: 'post',
        url: host + url,  
        data: qsParam
      }).then(res => {
        // 401 //token过期
        // 402 //没登录
        // 100 //成功
        if(res.data.code == 401){
          window.localStorage.removeItem('user')
          window.localStorage.removeItem('userInfo')
          window.localStorage.removeItem('token')
          Toast.info('账户过期,请重新登录', 2)
          window.location.href = window.location.href.split("#")[0]
          return false
        }
        console.log(res)
        resolve(res)
      })
    } else {
      console.log('token false')
      window.location.href = window.location.href.split("#")[0]
    }
  })
}

const postCard = (url, params = {}) => {
  return new Promise((resolve, reject) => {
    let param = { ...params }
    let token = window.localStorage.getItem('token')
    if(token != "" && token != undefined && token != 'undefined'){
      axios({
        headers: {
          //content-type": "application/x-www-form-urlencoded",
          "content-type": "application/json",
          "token": token
        },
        method: 'post',
        url: host + url,  
        data: param
      }).then(res => {
        // 401 //token过期
        // 402 //没登录
        // 100 //成功
        if(res.data.code == 401){
          window.localStorage.removeItem('user')
          window.localStorage.removeItem('userInfo')
          window.localStorage.removeItem('token')
          Toast.info('账户过期,请重新登录', 2)
          window.location.href = window.location.href.split("#")[0]
          return false
        }
        console.log(res)
        resolve(res)
      })
    } else {
      console.log('token false')
      window.location.href = window.location.href.split("#")[0]
    }
  })
}

const postNoToken = (url, params = {}) => {
  return new Promise((resolve, reject) => {
    let qsParam = qs.stringify(params)
    axios({
      headers: {
        "content-type": "application/x-www-form-urlencoded",
      },
      method: 'post',
      url: host + url,  
      data: qsParam
    }).then(res => {
      console.log(res)
      resolve(res)
    })
  })
}

const postNoTokenCode = (url, params = {}) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url: host + url,  
      data: params
    }).then(res => {
      console.log(res)
      resolve(res)
    })
  })
}

const postEncod = (url, params = {}) => {
  return new Promise((resolve, reject) => {
    let param = { ...params };
    let tokenSys = window.localStorage.getItem('tokenSys')
    axios({
      headers: {
        "content-type": "application/x-www-form-urlencoded",
        "tokenSys": tokenSys
      },
      method: 'post',
      url: host + url,  
      data: param
    }).then(res=>{
      console.log(res)
      resolve(res)
    })
  })
}

const postFile = (url, params = {}) => {
  return new Promise((resolve, reject) => {
    //let param = { ...params };
    let token = window.localStorage.getItem('token')
    axios({
      headers: {
        "content-type": "multipart/form-data",
        "token": token
      },
      method: 'post',
      url: host + url,  
      data: params
    }).then(res=>{
      console.log(res)
      resolve(res)
    })
  })
}

const get = (url, params = {}) => {
  return new Promise((resolve, reject) => {
    let param = { ...params };
    //let qsParam = qs.stringify(params)
    let token = window.localStorage.getItem('token')
    //token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiNDciLCJpc3MiOiJTZXJ2aWNlIiwidGltZSI6MTYzMTA5MDQ4NDA2MywiaWF0IjoxNjMxMDkwNDg0fQ.-5YDaphwTJGkgbSijHpE00icNufb1zKsH8OweJAJbAw'
    if(token != "" && token != undefined && token != 'undefined'){
      axios({
        headers: {
          //"content-type": "application/json",
          "token": token
        },
        method: 'get',
        url: host + url,  
        params: param
      }).then(res=>{
        if(res.data.code == 401){
          debugger
          window.localStorage.removeItem('user')
          window.localStorage.removeItem('userInfo')
          window.localStorage.removeItem('token')
          Toast.info('账户过期,请重新登录', 2)
          window.location.href = window.location.href.split("#")[0]
          return false
        }
        console.log(res)
        resolve(res)
      })
    } else {
      window.location.href = window.location.href.split("#")[0]
    }
  })
}

//医生的token
const getTokenDoc = (url, params = {}) => {
  return new Promise((resolve, reject) => {
    let param = { ...params };
    let tokenDoc = window.localStorage.getItem('tokenDoc')
    console.log('tokenDoc: ' + tokenDoc)
    if(tokenDoc!="" && tokenDoc!=undefined&&tokenDoc!='undefined'){
      console.log('tokenDoc true')
      axios({
        headers: {
          "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
          "token": tokenDoc,
        },
        method: 'get',
        url: host + url,  
        params: param
      }).then(res=>{
        console.log(res)
        resolve(res)
      })
    } else {
      console.log('tokenDoc false')
      let str = window.location.href.split("#")[0]
      //window.location.href = str
    }
  })
}

//不要token的请求
const getNoToken = (url, params = {}) => {
  return new Promise((resolve, reject) => {
    let param = { ...params };
    axios({
      headers: {
        "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
      method: 'get',
      url: host + url,  
      params: param,
    }).then(res=>{
      console.log(res)
      resolve(res)
    })
  })
}

//获取验证码图片那个
const getBlob = (url, params = {}) => {
  return new Promise((resolve, reject) => {
    let param = { ...params };
    axios({
      method: 'get',
      responseType: 'blob',
      url: host + url,  
      data: param,   
    }).then(res=>{
      console.log(res)
      resolve(res)
    })
  })
}

export {post,get,getBlob,postEncod,postNoToken,getNoToken,getTokenDoc,post_applets,get_applets,postFile,postNoTokenCode,postCard};
